<template>
  <c-tile-btn
    icon="mdi-close"
    data-id="dialog-close-button"
    :tooltip="$t('inri.common.close')"
    small
    class="absolute right-0 top-0"
  />
</template>
